interface ActiveElementHandlerProps {
    activeElement: HTMLElement,
    action: () => void
}

export const handleActiveElement = (props: ActiveElementHandlerProps) => {
    if (props.activeElement.id !== 'dni'){
        if (props.activeElement) {
            props.activeElement.blur();
        }
        props.action();
    }
}
